import React, { useState, useEffect } from 'react';
import Layout from '../../components/Layout/Layout';
import axios from 'axios';
import toast from 'react-hot-toast';
import { dateInDMY } from '../../Helpers';
import { SERVER_API } from '../../fileWithConstants';

const FabricRecoverList = () => {
  const [recoverData, setRecoverData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getRecoverData = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(
        `${SERVER_API}/api/v1/fabric/get-fabric-recover-list`
      );

      if (data?.success) {
        setRecoverData(data.recoverData || []);
      } else {
        toast.error(data?.message || 'Failed to load recover history');
      }
    } catch (error) {
      console.error(error);
      toast.error('Error while fetching recover history');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getRecoverData();
  }, []);

  return (
    <Layout title="Recovered Fabric List">
      <div className="container">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h1 className="page-title m-0">Recovered Fabric History</h1>
          <button className="btn btn-primary btn-sm" onClick={getRecoverData}>
            Refresh
          </button>
        </div>

        <div className="table-box">
          <table className="table table-responsive table-hover table-sticky">
            <thead>
              <tr>
                <th>#</th>
                <th className="text-center">Fabric</th>
                <th className="text-center">Than No</th>
                <th className="text-center">Recover Qty</th>
                <th className="text-center">Type</th>
                <th className="text-center">Remark</th>
                <th className="text-center">Recovered By</th>
                <th className="text-center">Recover Date</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="8" className="text-center py-4">
                    Loading...
                  </td>
                </tr>
              ) : recoverData.length > 0 ? (
                recoverData.map((row, index) => (
                  <tr key={row.id}>
                    <td>{index + 1}</td>
                    <td className="text-center">{row.fabric_name}</td>
                    <td className="text-center">{row.than_no}</td>
                    <td className="text-center">{row.recover_qty}</td>
                    <td className="text-center">{row.recover_type}</td>
                    <td>{row.remark}</td>
                    <td className="text-center">
                      {row.recovered_by || row.created_by || '-'}
                    </td>
                    <td className="text-center">
                      {dateInDMY(row.created_at)}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center py-4">
                    No recover history found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
};

export default FabricRecoverList;